export const WebViewOAuthHandler = () => ({
  init() {
    this.bindOAuthButtons()
  },

  isTrueBrowser() {
    const ua = navigator.userAgent

    // 桌面瀏覽器檢測
    const isDesktop = !(/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua))

    if (isDesktop) {
      return (
        (ua.includes('Chrome/') && !ua.includes('Mobile')) ||
        (ua.includes('Firefox/') && !ua.includes('Mobile')) ||
        (ua.includes('Safari/') && ua.includes('Version/') && !ua.includes('Mobile')) ||
        ua.includes('Edge/') ||
        ua.includes('Edg/') ||
        ua.includes('Opera/')
      )
    }

    // 行動裝置瀏覽器檢測
    return (
      ua.includes('CriOS/') ||      // Chrome iOS
      ua.includes('FxiOS/') ||      // Firefox iOS
      ua.includes('EdgiOS/') ||     // Edge iOS
      ua.includes('OPiOS/') ||      // Opera iOS
      // Safari iOS (需要同時包含 Safari 和 Version，但不包含 WebView 標識)
      (ua.includes('Safari/') && ua.includes('Version/') && ua.includes('Mobile') && !ua.includes('WebView'))
    )
  },

  shouldRedirectToExternalBrowser() {
    return !this.isTrueBrowser()
  },

  openInExternalBrowser(url) {
    try {
      // 方法 1: 使用 window.open 嘗試在外部瀏覽器開啟
      const opened = window.open(url, '_blank', 'noopener,noreferrer')

      // 方法 2: 如果 window.open 失敗，使用 a 標籤方式
      if (!opened || opened.closed || typeof opened.closed === 'undefined') {
        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        link.rel = 'noopener noreferrer'

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }

      return true
    } catch (error) {
      console.error('無法開啟外部瀏覽器:', error)
      return false
    }
  },


  handleOAuthClick(event, provider = 'google') {
    // 如果不需要跳轉到外部瀏覽器，讓表單正常提交
    if (!this.shouldRedirectToExternalBrowser()) {
      return true
    }

    event.preventDefault()

    const currentUrl = window.location.href

    const success = this.openInExternalBrowser(currentUrl)

    if (!success) {
      alert('無法開啟外部瀏覽器，請手動在瀏覽器中開啟此頁面進行登入')
    }

    return false
  },

  bindOAuthButtons() {
    const googleForm = document.querySelector('form[action*="google_oauth2"]')
    if (googleForm) {
      googleForm.addEventListener('submit', (event) => {
        this.handleOAuthClick(event, 'google')
      })
    }

    const facebookForm = document.querySelector('form[action*="facebook"]')
    if (facebookForm) {
      facebookForm.addEventListener('submit', (event) => {
        this.handleOAuthClick(event, 'facebook')
      })
    }

    const wechatForm = document.querySelector('form[action*="wechat"]')
    if (wechatForm) {
      wechatForm.addEventListener('submit', (event) => {
        this.handleOAuthClick(event, 'wechat')
      })
    }

    const oauthForms = document.querySelectorAll('form[action*="/auth/"]')
    oauthForms.forEach(form => {
      if (!form.hasAttribute('data-webview-handler-bound')) {
        form.addEventListener('submit', (event) => {
          const action = form.getAttribute('action')
          const provider = action.split('/').pop()
          this.handleOAuthClick(event, provider)
        })
        form.setAttribute('data-webview-handler-bound', 'true')
      }
    })
  },

  getEnvironmentInfo() {
    const ua = navigator.userAgent
    return {
      userAgent: ua,
      isTrueBrowser: this.isTrueBrowser(),
      shouldRedirect: this.shouldRedirectToExternalBrowser(),
      isDesktop: !(/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)),
      hasServiceWorker: 'serviceWorker' in navigator,
      hasShare: 'share' in navigator,
      hasChrome: window.chrome !== undefined
    }
  }
})
